import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class OrganismsService {
  public urlOrganisms: string = `${environment.apiPrestadorServ.context}${environment.apiPrestadorServ.methods.organisms}`;
  public urlOrganismsDetail: string = `${environment.apiPrestadorServ.context}`;

  constructor(private http: HttpClient) {}

  getOrganismsList(page: number, size: number, search?: string): Promise<any> {
    return this.http
      .get<any>(
        `${this.urlOrganisms}?size=${size}&page=${page}&search=${search}`
      )
      .toPromise();
  }

  getOrganimsDetails(id: string): Promise<any> {
    return this.http.get<any>(`${this.urlOrganismsDetail}/${id}`).toPromise();
  }
}
